import InputSelect from './inputSelect'

export default InputSelect